import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-hbm-bdi-prompt',
  templateUrl: './prompt.component.html'
})
export class PromptComponent implements OnInit {

  constructor(public modalService: ModalService) { }

  ngOnInit(): void { }
}
